import axios from "axios";
const basePath = process.env.VUE_APP_HZMB_GH_BASE_PATH;

/**
 * 根據服務類型獲取取消原因
 * @param {*} serviceType 
 * @returns 
 */
const getReasons = (serviceType) => {
  return axios.get(`${basePath}/protected/api/v1/reason-template`, {
    params: {
      serviceType: serviceType
    }
  }).then(res => res.data)
}

export default {
  getReasons
};
